export default __webpack_public_path__ + "static/media/pressedIcon.1b856d9d.svg";